import React, { Component } from 'react'

import { Container, Row, Col } from 'reactstrap'
import JobsList from './JobsList'
import '../Listing.css'
import MaintenanceListHeader from "../MaintenanceListHeader"
import RestrictedSection from "../../Components/RestrictedSection"
import { buildPresets } from "../../Filters/presetFilters"

import withApolloClient from '../../withApolloClient'

// Jobs has no default filters -- unlike Car Issues, the legacy bar carried no
// preselected status/stage for this tab, so there is nothing to express as a
// preset. It still gets the Advanced Filters control, just with no presets.
const JOB_PRESETS = buildPresets([])

class JobContainer extends Component {
    constructor(props) {
        super(props)
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the declared (empty) set.
        this.state = {
            activeTab: "Jobs",
            filterValues: {},
            presets: JOB_PRESETS,
            defaultPresets: JOB_PRESETS,
        }
    }

    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    render() {
        return (
            <RestrictedSection requiredPermission="view_job">
                <Container fluid className="bos-listing-container">
                    <MaintenanceListHeader
                        activeTab={this.state.activeTab}
                        filterValues={this.state.filterValues}
                        defaultFilters={["-id"]}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        presets={this.state.presets}
                        setPresets={this.setPresets}
                        defaultPresets={this.state.defaultPresets}
                    />
                    <Row>
                        <Col sm="12">
                            <JobsList
                                currentUser={this.props.currentUser}
                                presets={this.state.presets}
                                searchTerm={this.state.filterValues && this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : ""}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}


export default withApolloClient(JobContainer)
